// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"03b61693","32":"d48acda1","45":"f5c32cea","95":"47508fd2","225":"71bee45e","389":"5580c3fb","453":"82a2cd5a","480":"3e17265f","486":"e60f6872","491":"2c6ab9c4","542":"c42dcb60","595":"c702f132","718":"4f1bf794","840":"a3c5ccee"}[chunkId] + ".chunk.js";
};